<template>
    <router-link class="ui-link"
        :to="to"
        @click="$emit('click')"
        v-if="to"
        :style="styles"
    >
        <span class="text">{{ text }}</span>
        <span  v-if="showIcon" class="ui-icon icon-icon_arrow-right"></span>
    </router-link>
    <a class="ui-link"
        :href="href"
        @click="$emit('click')"
        :style="styles"
        :target="target"
        v-else
    >
        <span class="text">{{ text }}</span>
        <span  v-if="showIcon" class="ui-icon icon-icon_arrow-right"></span>
    </a>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    props: {
        href: String,
        to: String,
        text: String,
        showIcon: {
            type: Boolean,
            default: true
        },
        size: {
            type: Number,
            default: 18
        },
        target: {
            type: String,
            default: '_self'
        }
    },
    computed:{
        styles(): Record<string, string> {

            return {
                '--font-size': this.size + 'px'
            };

        }
    }
});
</script>

<style lang="less" scoped>
.ui-link{
    .text{
        font-size: var(--font-size);
        font-weight: 500;
    }
    .ui-icon{
        font-size: calc(var(--font-size) - 1px);
    }
}
</style>
